import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Icon } from '@iconify/react'
import AccessDeniedSvg from '@app/assets/images/access-denied.svg?url'
import urls from '@app/routes/urls'
import Button from '@app/components/Button'
import Flex from '@app/backoffice/Flex'
import S from './AccessDenied.styles'

const AccessDenied = () => {
  const navigate = useNavigate()

  const logout = () => {
    navigate(urls.signOut)
  }

  return (
    <S.Main>
      <S.Content>
        <img src={AccessDeniedSvg} alt="Access Denied" />
        <h3>Access Denied</h3>
        <p>Your user account does not have the necessary permissions to view the requested resource.</p>
        <Button onClick={logout}>Logout</Button>
        <S.Footer>
          <Flex align="center">
            <Icon icon="bx:info-square" fontSize={24} />
            <p>Contact a system administrator if you think you should be able to.</p>
          </Flex>
        </S.Footer>
      </S.Content>
    </S.Main>
  )
}

export default AccessDenied
